/*=========================================================================================
  File Name: getters.js
  namespace: iframes
  Description: Vuex Store - IFrame getters
==========================================================================================*/

const getters = {
  getRatingReportList: state => {
    return {
      items: state.results || [],
      total: state.count || 0
    }
  },
  getRatingReportEntries: state => {
    return state.iframeList
  },
}

export default getters
